import { create } from "zustand";

import { getSettingAndAssignMillionLintOptimization } from "@faire/retailer/settings/getSettingAndAssignMillionLintOptimization";

interface useFilterSectionSelectedChange {
  version: number;
  optionChanged: () => void;
}

export const useFilterSectionSelectedChange =
  create<useFilterSectionSelectedChange>((set, get) => ({
    version: 1,
    optionChanged: () => {
      const shouldMemoMillionLint =
        getSettingAndAssignMillionLintOptimization();
      if (shouldMemoMillionLint) {
        set({ version: get().version + 1 });
      }
    },
  }));
